module.exports = __webpack_public_path__ + "static/media/PE.20bd6f7b.svg";